import React, { useEffect, useState } from 'react'
import '../../Admin/Dashboard/DashboardStyle.css'
import ReactApexChart from 'react-apexcharts';
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from 'swiper';
import './MeDashboardStyle.css'
import Button from '../../../components/Button/Button';
import CardDs from '../../../components/CardDs/CardDs';
import MnRequest from '../../../components/MnRequest/MnRequest';
import { useDispatch, useSelector } from 'react-redux';
import { clearState, getMenteeCallsActivity, getMenteePerformance, getTopRatedMentors, getUpcomingInterviewDetails, menteeData } from '../../../reducer/menteeSlice';
import moment from 'moment';
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import Skeleton from 'react-loading-skeleton';

const MeDashboard = () => {

    
    // slider
    const navigationNextRefds = React.useRef(null);
    const navigationPrevRefds = React.useRef(null);
    
    const navigationNextRefNew = React.useRef(null);
    const navigationPrevRefNew = React.useRef(null);

    //states
  const [totalCalls, setTotalCalls] = useState([]);
  const [completedCalls, setCompletedCalls] = useState([]);
  const [cancelledCalls, setCancelledCalls] = useState([]);
  const [rescheduledCalls, setRescheduledCalls] = useState([]);
  const [unattendedCalls, setUnttendedCalls] = useState([]);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");

    const { isFetching, isTopMentorFetching, isDashboardFetching, isPerformanceFetching, isSuccess, isError, errorMessage, upcomingCalls, menteeCallsData, menteePerformance, topRatedMentors } = useSelector(menteeData);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getLastWeekDays = () => {
        var result = [];
        for (var i=1; i<8; i++) {
            var d = new Date();
            d.setDate(d.getDate() - i);
            result.push( moment(d).format("ddd") )
        }
    
        return result.reverse();
    };

    useEffect(() => {
        dispatch(getUpcomingInterviewDetails({}));   
        dispatch(getMenteeCallsActivity());
        dispatch(getMenteePerformance());
        dispatch(getTopRatedMentors());
    },[])

    useEffect(() => {
    if(menteeCallsData?.callsGraph?.length > 0) {
      const days = getLastWeekDays();
      let total = [];
      let completed = [];
      let cancelled = [];
      let rescheduled = [];
      let unattended = [];
      days.forEach((day, index) => {
        menteeCallsData?.callsGraph?.forEach((item) => {
          if(day === moment(item?.date).format("ddd")) {
            total.push(item?.total);
            completed.push(item?.completed);
            cancelled.push(item?.cancelled);
            rescheduled.push(item?.rescheduled);
            unattended.push(item?.noshow);
          }
        });
        if(total?.length <= index) total.push(0)
        if(completed?.length <= index) completed.push(0)
        if(cancelled?.length <= index) cancelled.push(0)
        if(rescheduled?.length <= index) rescheduled.push(0)
        if(unattended?.length <= index) unattended.push(0)
      });
      setTotalCalls(total);
      setCompletedCalls(completed);
      setCancelledCalls(cancelled);
      setRescheduledCalls(rescheduled);
      setUnttendedCalls(unattended);
    }
  },[menteeCallsData])

    useEffect(() => {
        if(isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    },[isError]);

    const options2 = {
        chart: {
          type: 'bar',
          height: 250,
          stacked: false // Set stacked to false to allow grouping
        },
        fill: {
          colors: ["#0E77D3"]
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '25%', // Adjust the width of the bars
            grouped: true, // Set grouped to true to group the bars
            borderRadius: "4",
          }
        },
        series: [
          {
            name: '',
            data: totalCalls
          }
        ],
        xaxis: {
          categories: getLastWeekDays()
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          marker: false,
          x: {
            show: false
          },
          y: {
            formatter: function (value, { seriesIndex, dataPointIndex }) {
              if (seriesIndex === 0) {
                const cancelled = cancelledCalls[dataPointIndex];
                const completed = completedCalls[dataPointIndex];
                const unattended = unattendedCalls[dataPointIndex];
                const rescheduled = rescheduledCalls[dataPointIndex];
      
                return `
                  <div class="flexDiv">
                      <div class="custom-tooltip-item tooltipHeading">Total Calls: <span class="dashboardValue">${value}</span></div>
                    
                      <div class="flexColumn">
                        <div class="dataDiv">
                          <div class="custom-tooltip-item ">Cancelled: ${cancelled}</div>
                          <div class="custom-tooltip-item ">Completed: ${completed}</div>
                        </div>
                        <div class="dataDiv">
                          <div class="custom-tooltip-item ">No Show: ${unattended}</div>
                          <div class="custom-tooltip-item ">Rescheduled: ${rescheduled}</div>
                        </div>
                      </div>
      
                  </div>
                `;
              }
            }
          },
          enabled: true,
          style: {
            fontSize: '12px',
            fontFamily: undefined
          }
        }
      };

    var options3 = {
        chart: {
            id: "basic-bar"
        },
        xaxis: {
            categories: ["Total calls"],
            labels: {
                show: false,
            }
        },
        yaxis: {
            labels: {
                show: false,
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                colors: ['#000']
              },
              formatter: function (val) {
                if(val) return val + '%';
              },
        },
        fill: {
            colors: ["#7757F4", "#7BC896", "#0E77D3", "#EF5350"]
        },
        tooltip: {
            enabled: false,
            style: {
                color: ["#fff"]
            },
            marker: false
        },
        legend: {
            show: false
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                borderRadiusApplication: 'end',
                columnWidth: '200%',
                distributed: true,
                dataLabels: {
                    position: "top"
                }
            }
        },
        series: [
            {
                name: "Completed",
                data: [null, (menteePerformance?.length > 0 ? ((menteePerformance[0]?.completed / menteePerformance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "Rescheduled",
                data: [null, null, (menteePerformance?.length > 0 ? ((menteePerformance[0]?.rescheduled / menteePerformance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "Cancelled",
                data: [null, null, null, (menteePerformance?.length > 0 ? ((menteePerformance[0]?.cancelled / menteePerformance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "No Show",
                data: [null, null, null, null, (menteePerformance?.length > 0 ? ((menteePerformance[0]?.noshow / menteePerformance[0]?.total) * 100 ).toFixed(0) : 0), null]
            },
        ]
    };

    return (
        <>
        <div className="AdDashboardMaindivwrap">

            <div className="AdCardMaindivWrap boxwrapMedash">

             <div className="flexboxdastopsmallbox">
                <div className="Menteewrapbox Wrapperforblock cardbordercolor">
                        <div className="mnmtcountgraph flex gap-6">
                            <h3 className='chartheading mb6'>{isDashboardFetching ? <Skeleton width={"100px"} /> : menteeCallsData?.totalCalls ?? 0}</h3>
                            {/* <span className='mtsgrapg bggreen'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.03457 5.15875C8.93957 5.15875 8.84457 5.12375 8.76957 5.04875L5.99957 2.27875L3.22957 5.04875C3.08457 5.19375 2.84457 5.19375 2.69957 5.04875C2.55457 4.90375 2.55457 4.66375 2.69957 4.51875L5.73457 1.48375C5.87957 1.33875 6.11957 1.33875 6.26457 1.48375L9.29957 4.51875C9.44457 4.66375 9.44457 4.90375 9.29957 5.04875C9.22957 5.12375 9.12957 5.15875 9.03457 5.15875Z" fill="#7BC896" />
                                <path d="M6 10.6259C5.795 10.6259 5.625 10.4559 5.625 10.2509V1.83594C5.625 1.63094 5.795 1.46094 6 1.46094C6.205 1.46094 6.375 1.63094 6.375 1.83594V10.2509C6.375 10.4559 6.205 10.6259 6 10.6259Z" fill="#7BC896" />
                            </svg>11%</span> */}
                        </div>
                        <p className='text2'>{isDashboardFetching ? <Skeleton width={"200px"} /> : 'Total number of Calls'}</p>

                        {/* <div className="AdgraphDesigncard">
                            <ReactApexChart
                                options={options}
                                series={options.series}
                                type="area"
                                width="100%"
                                height="150px"
                            />
                        </div> */}
                    </div>

                <div className="Menteewrapbox Wrapperforblock cardbordercolor">
                    <div className="mnmtcountgraph flex gap-6">
                        <h3 className='chartheading mb6'>{isDashboardFetching ? <Skeleton width={"50px"} /> : menteeCallsData?.callDuration ? (menteeCallsData?.callDuration / 3600).toFixed(1) ?? 0 : 0}</h3>
                  
                    </div>
                    <p className='text2'>{isDashboardFetching ? <Skeleton width={"200px"} /> : 'Total number of hours'}</p>

                </div>
             </div>

                <div className="AdCardSliderWrapper Wrapperforblock cardbordercolor boxwrapmefix">
                    <div className='AdDsCardheading flex-between'>
                        <div className="flex DsMentorheading">
                            <h3 className='DsCradtext'>Upcoming Calls</h3>
                            <span className='textBlue viewallButton text2' onClick={() => navigate("/mentee/call-records")}>View all</span>
                        </div>
                        <div className="arrowcardsDsAd flex">
                            <img src="assets/img/arrowleft.png" alt="" className='pointer eqiconarrow' ref={navigationNextRefds} />
                            <img src="assets/img/arrowright.png" alt="" className='pointer eqiconarrow' ref={navigationPrevRefds} />
                        </div>
                    </div>

                    <Swiper
                        slidesPerView={1}
                        modules={[Navigation]}
                        loop={false}
                        spaceBetween={20}


                        onSwiper={(swiper) => {
                            // Delay execution for the refs to be defined
                            setTimeout(() => {
                                // Override prevEl & nextEl now that refs are defined
                                swiper.params.navigation.prevEl = navigationPrevRefds.current
                                swiper.params.navigation.nextEl = navigationNextRefds.current

                                // Re-init navigation
                                swiper.navigation.destroy()
                                swiper.navigation.init()
                                swiper.navigation.update()
                            })
                        }}
                        navigation={{
                            // Both prevEl & nextEl are null at render so this does not work
                            prevEl: navigationPrevRefds.current,
                            nextEl: navigationNextRefds.current,
                        }}
                        onBeforeInit={(swiper) => {
                            swiper.navigation.nextEl = navigationNextRefds.current;
                            swiper.navigation.prevEl = navigationPrevRefds.current;
                        }}

                        className="mySwiper">

                        <div className='AdswiperWrappermain'>
                        {isFetching ? 
                        <MnRequest imgLoading={<Skeleton circle width={"50px"} height={"50px"} />} name={<Skeleton width={"100px"} />} type={<Skeleton width={"200px"} />} dataclass="fistdicfull" 
                        company="Agenda:" compdata={<Skeleton width={"500px"} />} exp=" Date:" expdata={<Skeleton width={"100px"} />} dom="Time:" domdata={<Skeleton width={"100px"} />}
                        />
                         :
                        upcomingCalls?.calls?.length > 0 ? upcomingCalls?.calls?.slice(0,9)?.map((item, index) => (
                                <SwiperSlide >
                                    <MnRequest profileImg={item?.mentor?.profileImg} joinbtn={item?.meetingLink} name={item?.mentor?.firstName ? `${item?.mentor?.firstName} ${item?.mentor?.lastName}` : "---"} type={item?.mentor?.profession?.designation? item?.mentor?.profession?.designation : "---"} dataclass="fistdicfull" 
                                        company="Agenda:" compdata={item?.agenda ? item?.agenda : "---"} exp=" Date:" expdata={item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("DD MMM YYYY") : "---"} dom="Time:" domdata={item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}
                                    />
                                </SwiperSlide>
                            )) : "No Upcoming calls"}
                        </div>
                    </Swiper>

                </div>

            </div>

            <div className="AdDashBoardMid">

                <div className="AdGraphwrapMntWrap flex">

                    <div className="AdleftgraphMnt Adbackwrapbox Mebackwrapboxds">
                        <div className="AdheadingwarpTab flex-between">
                            <div className="Adheadingtab">
                                <h3 className='heading-2 mb-6'>{isDashboardFetching ? <Skeleton width={"100px"} /> : 'Call Activity'}</h3>
                                <p className='text2'>{isDashboardFetching ? <Skeleton width={"110px"} /> : 'Count of total calls'}</p>
                            </div>
                            {/* <div className="Multibtntabwrap flex gap-10">
                                <div className="btnweek active">Week</div>
                                <div className="btnweek">Month</div>
                                <div className="btnweek">Year</div>
                            </div> */}
                        </div>
                        <div className="Dsmngrapgtext3 flex mt-30 gap-6">
                            <div className="mnmtcountgraph flex gap-6">
                                <h3>{isDashboardFetching ? <Skeleton width={"50px"} /> : menteeCallsData?.totalCallsWeekly ?? 0}</h3>
                                {/* <span className='mtsgrapg'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.03457 5.15875C8.93957 5.15875 8.84457 5.12375 8.76957 5.04875L5.99957 2.27875L3.22957 5.04875C3.08457 5.19375 2.84457 5.19375 2.69957 5.04875C2.55457 4.90375 2.55457 4.66375 2.69957 4.51875L5.73457 1.48375C5.87957 1.33875 6.11957 1.33875 6.26457 1.48375L9.29957 4.51875C9.44457 4.66375 9.44457 4.90375 9.29957 5.04875C9.22957 5.12375 9.12957 5.15875 9.03457 5.15875Z" fill="#7BC896" />
                                    <path d="M6 10.6259C5.795 10.6259 5.625 10.4559 5.625 10.2509V1.83594C5.625 1.63094 5.795 1.46094 6 1.46094C6.205 1.46094 6.375 1.63094 6.375 1.83594V10.2509C6.375 10.4559 6.205 10.6259 6 10.6259Z" fill="#7BC896" />
                                </svg>  11% from last month</span> */}
                            </div>

                            {/* <p className='text2'>Total count of calls completed in this duration</p> */}
                        </div>

                        <div>
                            {isDashboardFetching ? 
            <div>
            {[...Array(5)].map((_, index) => (
              <Skeleton key={index} height={30} style={{ marginBottom: '10px' }} />
            ))}
          </div>
            :
            <ReactApexChart className={'mt-30'}
                                options={options2}
                                series={options2.series}
                                type="area"
                                width="100%"
                                height="290px"
                            />}
                        </div>

                    </div>

                    <div className="AdrightgraphMnt Adbackwrapbox Mebackwrapboxds">
                        <div className="AdheadingwarpTab flex-between">
                            <div className="Adheadingtab">
                                <h3 className='heading-2 mb-6'>Performance <span className='smallText text2'>(Current month)</span></h3>
                                <p className='text2'>{menteePerformance?.length > 0 ? menteePerformance[0]?.total ? menteePerformance[0]?.total : 0 : 0} Total Calls</p>
                            </div>
                            {/* <label htmlFor="date" className='Cudatedesign'>
                                <input type="date" id='date' />
                            </label> */}
                        </div>
                        {isPerformanceFetching ? 
            <div>
            {[...Array(5)].map((_, index) => (
              <Skeleton key={index} height={50} style={{ marginBottom: '10px' }} />
            ))}
          </div>
            :<ReactApexChart className={'mt-30'}
                            options={options3}
                            series={options3.series}
                            type="bar"
                            width="100%"
                            height="290px"
                        />}

                        <div className="AdDataGraphwarp">
                            <div className="dataAdstatana w-100">
                                <div className='circleround'></div>
                                <p className='text2'> Completed</p>
                            </div>
                            <div className="dataAdstatana w-100">
                                <div className='circleround'></div>
                                <p className='text2'> Cancelled</p>
                            </div>
                            <div className="dataAdstatana w-100">
                                <div className='circleround'></div>
                                <p className='text2'> Rescheduled</p>
                            </div>
                            <div className="dataAdstatana w-100">
                                <div className='circleround'></div>
                                <p className='text2'> No show</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="AdDashBoardBottom">

                <div className=" Wrapperforblock">

                    <div className="mnmtcountgraph flex-between mb40">
                        <div>
                            <h2 className="smallHeading heading-2">Top Rated Mentors</h2>
                            <p className="smallText text2">Averag of mentors with top ratings</p>
                        </div>

                        <Button name={'View all'} className={'viewall'} onClick={() => navigate("/mentee/all-mentor")} />
                    </div>

                    <div className="AdgraphDesigncard MeTopMentorslider">
                        <div className="NextBtn swiperbtn swiperBtnNew" ref={navigationPrevRefNew}>
                            <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M12.3839 1.22677C12.872 1.71493 12.872 2.50638 12.3839 2.99454L3.26777 12.1107L12.3839 21.2268C12.872 21.7149 12.872 22.5064 12.3839 22.9945C11.8957 23.4827 11.1043 23.4827 10.6161 22.9945L0.616117 12.9945C0.127961 12.5064 0.127961 11.7149 0.616117 11.2268L10.6161 1.22677C11.1043 0.738618 11.8957 0.738618 12.3839 1.22677Z" fill="#737373" />
                            </svg>
                        </div>
                        <Swiper
                            slidesPerView={1.5}
                            spaceBetween={0}
                            breakpoints={{
                                640: {
                                    slidesPerView: 3,
                                },
                                768: {
                                    slidesPerView: 3,
                                },
                                1024: {
                                    slidesPerView: 6,
                                },

                            }}
                            modules={[Navigation]}
                            loop={false}
                            className="mySwiper"

                            onSwiper={(swiper) => {
                                // Delay execution for the refs to be defined
                                setTimeout(() => {
                                    // Override prevEl & nextEl now that refs are defined
                                    swiper.params.navigation.prevEl = navigationPrevRefNew.current
                                    swiper.params.navigation.nextEl = navigationNextRefNew.current

                                    // Re-init navigation
                                    swiper.navigation.destroy()
                                    swiper.navigation.init()
                                    swiper.navigation.update()
                                })
                            }}
                            navigation={{
                                // Both prevEl & nextEl are null at render so this does not work
                                prevEl: navigationPrevRefNew.current,
                                nextEl: navigationNextRefNew.current,
                            }}
                            onBeforeInit={(swiper) => {
                                swiper.navigation.nextEl = navigationNextRefNew.current;
                                swiper.navigation.prevEl = navigationPrevRefNew.current;
                            }}

                        >
                            {isTopMentorFetching ?
                                <div className='flex'>
                                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                                <CardDs imgLoading={<Skeleton circle height={"100px"} width={"100px"} />} rating={<Skeleton width={"30px"} />} name={<Skeleton width={"80px"} />} btn="View Profile" />
                                </div> 
                                :
                            topRatedMentors?.length > 0 ? topRatedMentors?.map((item, index) => (
                                <SwiperSlide className='mentorSlider' key={index}>
                                    <CardDs to={`/mentee/mentorProfile/${item?.id}`} userimg={item?.profileImg ? item?.profileImg : "/assets/img/User.png"} rating={(+item?.averageRating).toFixed(0) ?? 0} name={item?.firstName ? `${item?.firstName} ${item?.lastName}` : "---"} btn="View Profile" />
                                </SwiperSlide>
                            )) : <DatanotFound />}
                        </Swiper>
                        <div className="PreBtn swiperbtn swiperBtnNew" ref={navigationNextRefNew}>
                            <svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M0.616117 1.22677C1.10427 0.738618 1.89573 0.738618 2.38388 1.22677L12.3839 11.2268C12.872 11.7149 12.872 12.5064 12.3839 12.9945L2.38388 22.9945C1.89573 23.4827 1.10427 23.4827 0.616117 22.9945C0.127961 22.5064 0.127961 21.7149 0.616117 21.2268L9.73223 12.1107L0.616117 2.99454C0.127961 2.50638 0.127961 1.71493 0.616117 1.22677Z" fill="#737373" />
                            </svg>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        </>
    )
}

export default MeDashboard